import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import fabstech from '../images/fabstech.png';
import { FaMapMarkerAlt,FaRegEnvelope,FaFax} from 'react-icons/fa';
import {MdSmartphone,MdPhone} from 'react-icons/md';
import tanzania from '../images/tanzania.png';
import who_logo from '../images/who_logo.png';
class ContactUs extends Component {
    state = {  }
    render() { 
        const myStyle = {
            height:'100vh',
            backgroundColor:"#d3d3d3"
        }
        return (  
            <div style={myStyle}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-md-12 col-sm-12">
                           <div className="card">
                                   <div className="fabstech" style={{paddingTop:'20px',textAlign:'center',borderRadius:'3px',border:'1px solid #fff',backgroundColor:'#fff',marginTop:'10px'}}>
                                     <div><img src={fabstech} alt="" height='50px' width='50px'/></div>
                                     <i style={{color:'green'}}>&nbsp;Fabstech Limited</i><br/>
                                     <i>< FaMapMarkerAlt/>&nbsp;Plot No 186, Block C Mikocheni B, Coca Cola Rd</i><br/>
                                     <i><FaRegEnvelope/>&nbsp;Box 110311, Kinondoni, Dar es salaam</i><br/>
                                     <i><MdSmartphone/>&nbsp;+255 754 068 145</i><br/>
                                     <i><MdPhone/>&nbsp;+255 672 871 611</i><br/>
                                     <i>www.fabstech.com</i>
                                   </div>
                                    </div>
                                    <div className="card mt-3">
                                   <div className="tanzania" style={{paddingTop:'20px',textAlign:'center',borderRadius:'3px',border:'1px solid #fff',marginTop:'10px'}}>
                                            <div><img src={tanzania} alt="" height='50px' width='50px'/></div>
                                            <i style={{color:"#338f2f"}}>Ministry of Health, Community Development,<br/> Elderly and Children</i><br/>
                                            <i>&nbsp;University of Dodoma, College of Social Science and Humanity,<br/>Block No. 11</i><br/>
                                            <i><FaRegEnvelope/>&nbsp;Box 573, 40478 Dodoma, Tanzania</i><br/>
                                            <i><MdPhone/>&nbsp;Tel: +255 26 2963341/42/46</i><br/>
                                            <i><FaRegEnvelope/>&nbsp;ps@communitydevelopment.go.tz</i><br/>
                                            <i>www.moh.go.tz</i>
                                   </div>
                                   </div>
                                   <div className="card mt-3">
                                       <div className="who" style={{paddingTop:'20px',textAlign:'center',borderRadius:'3px',border:'1px solid #fff',marginTop:'10px'}}>
                                                  <div><img src={who_logo} alt="" height='50px' width='50px'/></div>
                                                  <i style={{color:'#008dc9'}}>The WHO Representative to Tanzania is Dr. Tigest Ketsela</i><br/>
                                                  <i><FaRegEnvelope/>&nbsp;Box 9292, Dar Es Salaam.</i><br/>
                                                  <i><MdPhone/>&nbsp;(255) 22 2116412/2113005/2111718</i><br/>
                                                  <i><FaFax/>&nbsp;Fax: +255 26 2963348</i><br/>
                                                  <i><FaRegEnvelope/>&nbsp;afwcotz@who.int</i>
                                       </div>
                                   </div>
                           </div>
                        </div>
                    </div>
                </div>
        );
    }
}
 
export default ContactUs;